import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { SafelyRenderHtml } from '@src/services';

const EndTextSection = ({ data }) => {
    const { html } = data || {};

    if (!html) {
        return null;
    }

    return (
        <section id="end-text" className="col-12 p-0">
            <Row className="p-0 footer-notes main-container-row">
                <Col>
                    {SafelyRenderHtml(html)}
                </Col>
            </Row>
        </section>
    );
};

EndTextSection.propTypes = {
    data: PropTypes.shape({
        html: PropTypes.string,
    }),
};

export default EndTextSection;
